import {useIntl} from 'react-intl';

import {useAppSelector} from 'stores/redux_store';

import {LinkVariantIcon} from '@time-webkit/all/icons/link-variant';
import {getCurrentTeam} from 'mattermost-redux/selectors/entities/teams';
import {getSiteURL} from 'utils/url';
import {ButtonCopyToClipboard} from 'components/button-copy-to-clipboard';
import {sendToStatist} from '@time-webkit/statist';

type Props = {
    teamId: string;
    containerId?: string;
}

export const LinkInviteMember = ({containerId, teamId}: Props) => {
    const intl = useIntl();
    const currentTeam = useAppSelector(getCurrentTeam);
    const inviteUrl = `${getSiteURL()}/signup_user_complete/?id=${currentTeam!.invite_id}`;

    return (
        <ButtonCopyToClipboard
            onClick={() => sendToStatist('team.invite.copyLink', {teamId})}
            containerId={containerId}
            icon={<LinkVariantIcon size={16} />}
            copyText={inviteUrl}
            messageSuccess={intl.formatMessage({
                id: 'invite.members.link_has_been_copied',
                defaultMessage: 'Link has been copied',
            })}
        >
            {
                intl.formatMessage({
                    id: 'invite.members.copy_invite_link',
                    defaultMessage: 'Copy invite link',
                })
            }
        </ButtonCopyToClipboard>
    );
};
